export default {
  root: function root() {
    return {
      textAlign: 'right'
    };
  }
};